export default [
  { label: 'Date', key: 'date' },
  { label: 'Company', key: 'company' },
  { label: 'Name', key: 'name' },
  { label: 'Email', key: 'email' },
  { label: 'Amount', key: 'amount' },
  { label: 'Type', key: 'type' },
  { label: 'Status', key: 'status' },
];
